<div class="side-bar" [class.side-bar-large]="!showMenuDetails">
  <div class="alterna-banners-container" >
    <mat-icon class="alterna-banner" [class.display-none]="!showMenuDetails" svgIcon="banner"></mat-icon>
    <div class="alterna-large-banner" [class.display-none]="showMenuDetails"></div>
  </div>
  <div class="icon-open-close  pointer" (click)="toggleMenu(showMenuDetails)" >
    <mat-icon class="alterna-icon-menu pointer" *ngIf="showMenuDetails == true" svgIcon="bars"></mat-icon>
    <mat-icon class="alterna-icon-menu pointer" *ngIf="showMenuDetails == false" svgIcon="crossMenu"></mat-icon>
  </div>
  <div class="alterna-icon-container alt-flex-column" *ngFor="let item of linksNavs; index as i;">
    <div class="icon-text-container alt-column-align-center pointer" (click)="showMore(i)" matTooltip="{{ item.title | translate }}" matTooltipPosition="right">
      <ng-container *ngIf="item.svg === true; else defaultIcon">
        <mat-icon class="alterna-icon-menu" *ngIf="activeIconMenu == i" [svgIcon]="item.iconActive"></mat-icon>
        <mat-icon class="alterna-icon-menu" [class.display-none]="activeIconMenu == i" [svgIcon]="item.icon"></mat-icon>
      </ng-container>
      <ng-template #defaultIcon>
        <mat-icon class="alterna-mat-icon-menu" *ngIf="activeIconMenu == i">{{ item.iconActive }}</mat-icon>
        <mat-icon class="alterna-mat-icon-menu" [class.display-none]="activeIconMenu == i">{{ item.icon }}</mat-icon>
      </ng-template>

      <p *ngIf="item.title" [class.display-none]="showMenuDetails" [class.alt-color-bran1]="activeIconMenu == i"
        class="alterna-title-icon-menu alt-inter-bold alt-size-16">{{ item.title | translate }}
      </p>
    </div>
  </div>
</div>
